import { ChakraProvider } from "@chakra-ui/react";
import { Global } from "@emotion/react";
import {
  AuthContextProvider,
  CustomCSSReset,
  LanguageProvider,
  theme,
} from "@questy/aura-cl";
import React, { Suspense, useEffect, useState } from "react";
import ReactDOM, { createPortal } from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AppAux from "./AppAux";
import SettingsContextProvider from "./context/SettingsContext";
import globalStyles from "./globalStyles";
import "./i18n";

export const queryClient = new QueryClient();

const getPageMountingPoint = () => {
  return document.getElementById("aura-spa-root");
};

const BaseApp = () => {
  // stan potrzebny tylko do wywołania rerender BaseApp, żeby zamontował się portal
  const [, setRerender] = useState<any>(null);

  useEffect(() => {
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    const callback: MutationCallback = (_, observer) => {
      const mainMountingPoint = getPageMountingPoint();
      if (
        mainMountingPoint &&
        !mainMountingPoint.classList.contains("react-mounted")
      ) {
        setRerender(new Date());
        mainMountingPoint.classList.add("react-mounted");
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <React.StrictMode>
      <BrowserRouter>
        <ChakraProvider theme={theme} resetCSS={false}>
          <CustomCSSReset />
          <Global styles={globalStyles} />
          <QueryClientProvider client={queryClient}>
            <AuthContextProvider>
              <LanguageProvider>
                <SettingsContextProvider
                  settings={[
                    "company_short_name_enabled",
                    "cookie_notice",
                    "currency_active",
                    "datera_server_address",
                    "default_currency",
                    "new_look_email_message",
                    "new_task_look",
                    "unique_serviced_product_serial",
                    "document_offer_question_position_drag_and_drop",
                    "new_look_list_filter_as_tag",
                  ]}
                >
                  <Suspense fallback={null}>
                    {document.getElementById("aura-spa-root")
                      ? createPortal(
                          <App />,
                          document.getElementById(
                            "aura-spa-root"
                          ) as HTMLElement
                        )
                      : null}
                    {createPortal(
                      <AppAux />,
                      document.getElementById(
                        "aura-spa-aux-root"
                      ) as HTMLElement
                    )}
                  </Suspense>
                </SettingsContextProvider>
              </LanguageProvider>
            </AuthContextProvider>
          </QueryClientProvider>
        </ChakraProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

ReactDOM.render(<BaseApp />, document.getElementById("aura-spa-custom"));
